import React from 'react';
import styled from 'styled-components';
import { Link, match } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { FormikValues } from 'formik';

import { CompensationSentenceParams } from 'types';
import Card from '../../components/molecules/card';
import Layout from '../../components/templates/layout';
import { useIntl } from '../../common/config/i18n';
import history from '../../app-router/history';
import { compensationSentenceActions, compensationSentencesSelectors } from '../../common/config/store';
import FormCompensationSentence from '../../components/templates/form-compensation-sentence';

const Wrapper = styled.div`
  margin: 5px;
`;
const StyledBreadcrumbWrapper = styled.div`
  margin: 10px 0 20px 20px;
`;
interface Props {
  match: match<Params>;
}
interface Params {
  id: string;
}

const CompensationSentence: React.FC<Props> = (props) => {
  const dispatch = useDispatch();
  const { t } = useIntl();
  const compensationSentencesData = useSelector(compensationSentencesSelectors.dataSelector);
  const { id: idOfCSToUpdate } = props.match.params; // CS: CompensationSentence

  const onSubmitHandler = (values: FormikValues) => {
    const compensationSentence = values as CompensationSentenceParams;
    dispatch(
      compensationSentenceActions.updateCompensationSentence(
        {
          ...compensationSentence,
        },
        () => history.push('/compensation-sentences')
      )
    );
  };

  const compensationSentence = compensationSentencesData?.find((cs) => cs.id.toString() === idOfCSToUpdate);

  if (idOfCSToUpdate && !compensationSentence) {
    history.push('/compensation-sentences');
    return null;
  }

  return (
    <div>
      <Layout />
      <Wrapper>
        <StyledBreadcrumbWrapper>
          <Link to="/compensation-sentences">{t('CompensationSentencePage', 'BACK')}</Link>
        </StyledBreadcrumbWrapper>

        <Card title={t('CompensationSentencePage', 'TITLE_UPDATE')}>
          <FormCompensationSentence onSubmit={onSubmitHandler} compensationSentence={compensationSentence} />
        </Card>
      </Wrapper>
    </div>
  );
};

export default CompensationSentence;
